// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"q6","image":"q7","topImage":"q8","fadedIn":"q9"};